export const alreadyLoadedScripts = [
  "axios.min.js",
  "bootstrap.bundle.min.js",
  "countdown.js",
  "counterup.js",
  "elevatezoom.js",
  "images-loaded.js",
  "index.min.js",
  "index.umd.min.js",
  "instafeed.js",
  "intlTelInput.min.js",
  "jquery-3.7.1.min.js",
  "js.js",
  "magnific-popup.js",
  "modernizr-3.11.7.min.js",
  "moment.min.js",
  "owl-carousel.js",
  "popper.js",
  "scrollup.js",
  "sdk.js",
  "slick.js",
  "smoothscroll.js",
  "sticky-sidebar.js",
  "sweetalert.min.js",
  "textillate.js",
  "theme-bootstrap.min.js",
  "theme-isotope.js",
  "theme-jquery-3.6.0.min.js",
  "theme-jquery-ui-touch-punch.min.js",
  "theme-jquery-ui.js",
  "theme-main.js",
  "theme-waypoints.js",
  "theme-wow.js",
  "v3.js",
];

export const FORBIDDEN_SCRIPTS = ["royal_preloader"];
